// https://vuex.vuejs.org/en/state.html

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  menu: [],
  tree: [],
  parent: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
